import authProvider from "./auth-provider";
import apiConfigs from "./api-config";

export default class BaseApi {
    readonly apiHost: string
    readonly apiPathDigitalId: string
    readonly apiPathFeature: string
    readonly apiPathSapProxy: string


    constructor() {
        const isGlobalEnabled = localStorage.getItem('isGlobalEnabled') === 'true'
        const configKey = (isGlobalEnabled ? 'global' : 'regional')

        this.apiHost = apiConfigs[configKey].apiHost ?? ''
        this.apiPathDigitalId = apiConfigs[configKey].paths.digitalId ?? ''
        this.apiPathFeature = apiConfigs[configKey].paths.feature ?? ''
        this.apiPathSapProxy = apiConfigs[configKey].paths.sapProxy ?? ''
    }

    checkStatusCode(status: number): boolean {
        return status >= 200 && status < 300
    }

    private async getValidToken(): Promise<string> {
        let token = await authProvider.getToken();

        // check if token is empty or null (indicating expiration)
        if (!token || token.trim() === '') {
            console.log('** Token not valid, waiting for component [aws-react] to perform login again...');
        }

        return token;
    }

    requestHeaderGet = async (moreHeaders?: any): Promise<RequestInit> => {
        let token = await this.getValidToken();
        const options: RequestInit = {
            method: "GET",
            headers: new Headers({
                'Authorization': 'Bearer ' + token,
                ...moreHeaders
            })
        }
        return options
    }

    requestHeaderPost = async (requestBody: any, moreHeaders?: any): Promise<RequestInit> => {
        let token = await this.getValidToken();
        const options: RequestInit = {
            method: "POST",
            headers: new Headers({
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json',
                ...moreHeaders
            }),
            body: moreHeaders && moreHeaders['Content-Type'] && moreHeaders['Content-Type'] !== 'application/json' ? requestBody : JSON.stringify(requestBody)
        };
        return options
    }

    requestHeaderPatch = async (requestBody: any, moreHeaders?: any): Promise<RequestInit> => {
        let token = await this.getValidToken();
        const options: RequestInit = {
            method: "PATCH",
            headers: new Headers({
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json',
                ...moreHeaders
            }),
            body: moreHeaders && moreHeaders['Content-Type'] && moreHeaders['Content-Type'] !== 'application/json' ? requestBody : JSON.stringify(requestBody)
        };
        return options
    }

    async genericResponse(response: any) {
        if (this.checkStatusCode(response.status)) {
            return {
                success: true
            }
        } else {
            return {
                error: true
            }
        }
    }
}
